export const FETCH_RAW_EVENT_REQUEST = 'FETCH_RAW_EVENT_REQUEST';
export const FETCH_RAW_EVENT_DATA = 'FETCH_RAW_EVENT_DATA';
export const FETCH_RAW_EVENT_ERROR = 'FETCH_RAW_EVENT_ERROR';
export const RESET_RAW_EVENT_DATA = 'RESET_RAW_EVENT_DATA';
